import { FC } from 'react';
import { ButtonLink, Icon, Icons } from '@silverfort/sf-components';
import { ProviderData } from './Types';

interface ProviderItemProps {
    provider: ProviderData;
    onAdd: () => void;
}

const ProviderItem: FC<ProviderItemProps> = ({ provider, onAdd }) => {
    return (
        <div
            className={`group h-8 text-12 font-sf font-medium flex items-center justify-between px-2 py-1 gap-1 rounded transition-colors hover:bg-sf-sunset-400 ${
                provider.active ? 'text-sf-white' : 'text-sf-gray-400'
            }`}>
            <div className="flex items-center space-x-2">
                <Icon
                    icon={dataSourceToIconMap[provider.name] || Icons.Integration}
                    className={provider.active ? 'text-sf-white' : 'text-sf-gray-400'}
                />
                <span>{provider.displayName}</span>
            </div>
            {!provider.active && (
                <div className="invisible group-hover:visible">
                    <ButtonLink
                        onClick={onAdd}
                        text={'ADD'}
                        className={
                            'text-transparent bg-gradient-to-r from-sf-sunset-200 to-sf-sunset-300 bg-clip-text hover:text-transparent'
                        }
                    />
                </div>
            )}
        </div>
    );
};

// missing icons jira task - AF-40854
const dataSourceToIconMap: Record<string, FC<React.SVGProps<SVGSVGElement>>> = {
    Aws: Icons.IntegrationAwsFlat,
    Gcp: Icons.IntegrationGCPFlat,
    Okta: Icons.IntegrationOktaSymbol,
    Rezonate: Icons.IntegrationRezonateFlat,
    Azure: Icons.IntegrationAzureFlat,
    AzureAd: Icons.IntegrationActiveDirectoryFlat,
    Kubernetes: Icons.IntegrationKubernetesFlat,
    Gsuite: Icons.IntegrationGSuiteFlat,
    Snowflake: Icons.IntegrationSnowflakeFlat,
    Github: Icons.IntegrationGithubFlat,
    Atlassian: Icons.IntegrationAtlassianFlat,
    Salesforce: Icons.IntegrationSalesforceFlat,
    Sap: Icons.IntegrationSAPFlat,
    Office365: Icons.IntegrationOffice365Flat,
    Tableau: Icons.IntegrationTableauFlat,
    External: Icons.IntegrationExternalFlat,
    Slack: Icons.IntegrationSlackFlat,
    Jira: Icons.IntegrationJiraFlat,
    Confluence: Icons.IntegrationConfluenceFlat,
    Gitlab: Icons.IntegrationGitlabFlat,
    Workday: Icons.IntegrationWorkdayFlat,
    ServiceNow: Icons.IntegrationServiceNowFlat,
    Greenhouse: Icons.IntegrationGreenhouseFlat,
    // Unknown: Icons.Unknown,
    CrowdStrike: Icons.IntegrationCrowdStrikeFlat,
    SentinelOne: Icons.IntegrationSentinelOneFlat,
    BambooHr: Icons.IntegrationBambooHrFlat,
    MicrosoftDefender: Icons.IntegrationMicrosoftDefenderFlat,
    MicrosoftIntune: Icons.IntegrationMicrosoftIntuneFlat,
    Cloudflare: Icons.IntegrationCloudflareFlat,
    Rapid7: Icons.IntegrationRapid7Flat,
    Zoom: Icons.IntegrationZoomFlat,
    Netsuite: Icons.IntegrationNetSuiteFlat,
    Zendesk: Icons.ServiceZendesk,
    Auth0: Icons.IntegrationAuth0Flat,
    Cybereason: Icons.IntegrationCyberReasonFlat,
    DataBricks: Icons.IntegrationDataBricksFlat,
    Jamf: Icons.IntegrationJamfFlat,
    Bitbucket: Icons.IntegrationBitbucketFlat,
    Docusign: Icons.IntegrationDocuSignFlat,
    HubSpot: Icons.IntegrationHubSpotFlat,
    Sharepoint: Icons.IntegrationSharePointFlat,
    // ElmoHr: Icons.ElmoHr,
    OracleCloud: Icons.IntegrationOracleCloudFlat,
    Splunk: Icons.IntegrationSplunkFlat,
    JumpCloud: Icons.IntegrationJumpCloudFlat,
    Figma: Icons.IntegrationFigmaFlat,
    Adobe: Icons.IntegrationAdobeFlat,
    Trello: Icons.IntegrationTrelloFlat,
    ClickUp: Icons.IntegrationClickUpFlat,
    Phrase: Icons.IntegrationPhraseFlat,
    Clockify: Icons.IntegrationClockifyFlat,
    Postman: Icons.IntegrationPostmanFlat,
    Lucidchart: Icons.IntegrationLucidChartFlat,
    Canva: Icons.IntegrationCanvaFlat,
    Dropbox: Icons.IntegrationDropboxFlat,
    Datadog: Icons.IntegrationDataDogFlat,
    OpenAi: Icons.IntegrationOpenAiFlat,
    Airtable: Icons.IntegrationAirTableFlat,
    Zapier: Icons.IntegrationZapierFlat,
    LastPass: Icons.IntegrationLastPassFlat,
    OnePassword: Icons.Integration1PasswordFlat,
    Bitwarden: Icons.IntegrationBitWardenFlat,
    HiBob: Icons.IntegrationHiBobFlat,
    Expensify: Icons.IntegrationExpensifyFlat,
    CircleCi: Icons.IntegrationCircleCiFlat,
    ActiveDirectory: Icons.IntegrationActiveDirectoryFlat,
    MongoAtlas: Icons.IntegrationMongoAtlasFlat,
    PingId: Icons.IntegrationPingIdentityFlat,
    // GenericHris: Icons.GenericHris,
    Radius: Icons.IntegrationActiveDirectoryFlat
};

export default ProviderItem;
